<template>
  <div
    v-if="!shouldHideFacilitySelect && facilityOptions && facilityOptions.length > 0"
  >
    <treeselect
      v-model="facility"
      class="w-50 rounded"
      style="background: #fff"
      :options="facilityOptions"
      :clearable="true"
      :disabled="facilityOptions.length === 1"
      :normalizer="normalizer"
      @select="changeFacility"
      :value-format="facilityOptions.length === 1 ? 'object' : 'id'"
    >
    </treeselect>
  </div>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axiosU from "@/core/services/api/auth";

export default {
  data() {
    return {
      facilityOptions: [],
      facility: null,
      setTimeoutBuscador: "",
      roleChangedCounter: 0,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  mounted() {
    window.addEventListener('role-changed', this.onRoleChanged)

    // Safely parse facility options first (needed to determine value format)
    try {
      const facilityOptionsData = localStorage.getItem("setFacilityOptions")
      if (facilityOptionsData) {
        const decoded = atob(facilityOptionsData)
        if (decoded && decoded.trim()) {
          this.facilityOptions = JSON.parse(decoded)
        } else {
          this.facilityOptions = []
        }
      } else {
        this.facilityOptions = []
      }
    } catch (error) {
      console.error('Error parsing setFacilityOptions from localStorage:', error)
      // Clear corrupted data
      localStorage.removeItem("setFacilityOptions")
      this.facilityOptions = []
    }

    // Safely parse Facility
    try {
      const facilityData = localStorage.getItem("Facility")
      if (facilityData) {
        const decoded = atob(facilityData)
        if (decoded && decoded.trim()) {
          const facilityObj = JSON.parse(decoded)
          // Si hay múltiples facilities, usar solo el ID (value-format='id')
          // Si hay una sola facility, usar el objeto completo (value-format='object')
          if (this.facilityOptions.length === 1) {
            this.facility = facilityObj
          } else {
            // Extraer solo el ID del objeto
            this.facility = facilityObj?.id || null
          }
        }
      }
    } catch (error) {
      console.error('Error parsing Facility from localStorage:', error)
      // Clear corrupted data
      localStorage.removeItem("Facility")
      this.facility = null
    }
  },
  methods: {
    onRoleChanged() {
      this.roleChangedCounter++
    },
    changeFacility(item) {
      // item puede ser un ID (number) o un objeto, dependiendo del value-format
      let facilityId;
      let facilityObj;
      
      if (typeof item === 'object' && item !== null) {
        // Si es un objeto, extraer el ID
        facilityId = item.id;
        facilityObj = item;
      } else {
        // Si es solo un ID, buscar el objeto completo en facilityOptions
        facilityId = item;
        facilityObj = this.facilityOptions.find(f => f.id === facilityId);
      }
      
      if (!facilityId) {
        console.error('No se pudo obtener el ID de la facility');
        return;
      }
      
      /* this.$pusher.unsubscribe(
        `presence-officeVisit.${
          JSON.parse(atob(localStorage.getItem("Facility"))).id
        }`
      ); */
      const datos = {
        facilities_id: facilityId,
      };
      axiosU.selectFacility(datos).then(({ facilities_id }) => {
        this.$variableGlobal.facility = facilityId;
        localStorage.setItem("facility", facilities_id);
        // Guardar el objeto completo de la facility
        if (facilityObj) {
          localStorage.setItem("Facility", btoa(JSON.stringify(facilityObj)));
        }
        /* this.$pusher.subscribe(
          `presence-officeVisit.${
            JSON.parse(atob(localStorage.getItem("Facility"))).id
          }`
        ); */
        window.location.reload();
      });
    },
  },
  computed: {
    shouldHideFacilitySelect() {
      // Ensure computed is reactive to role switches.
      const roleVersion = this.roleChangedCounter

      const storedUser = localStorage.getItem('userData')
      if (!storedUser) return false

      try {
        const parsed = JSON.parse(storedUser)
        const roles = parsed?.roles || []
        const currentRoleId = Array.isArray(roles) ? roles?.[0]?.id : null
        return [9, 10, 7, 8].includes(Number(currentRoleId)) && roleVersion >= 0
      } catch (error) {
        return false
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('role-changed', this.onRoleChanged)
  }
};
</script>

<style></style>
